import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { curLang, DatasetAnonymityRepo, DatasetRepo, DpFsVal, DpValue, EppPortlet, LinkConfig, Portlet, PortletAnonymityRepo, PortletRepo, UtilService, WEB_PATH_HOME } from '@gspwidget/util';
// import { GetDataOptions, WCStatus, WidgetComponent } from '@gspwidget/widget-core';
import { ClickEventConfig, registerLinkToPropEventHandler, registerOpenPortletFn, WidgetDevkitService } from '@gspwidget/widget-devkit';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import jexl from 'jexl'
import { deepMergeKey } from '@xircuit/sf';
import { GetDataOptions, WCStatus, WidgetComponent } from '../widget/widget.component';
import { fromPromise } from 'rxjs-compat/observable/fromPromise';

@Component({
  selector: 'lib-portlet',
  template: `
    <lib-widget
      #widget
      [fallbackTitle]="(title || title==='') ? title : innerPortlet?.name"
      [basicWidgetInfo]="innerPortlet?.widget"
      [propValues]="innerPortlet?.propValues"
      [instanceId]="instanceId"
      [getData]="getData"
      [linkMap]="linkMap"
      [isDevMode]="innerPortlet?.widget['isDevMode']"
      [widgetInstanceInfoMixin]="{ portletId: innerPortlet?.id }"
      [initFilterDpFsValList]="initFilterDpFsValList"
      (widgetInit)="handleWidgetInit()"
      (widgetCompCreated)="handleWidgetCompCreated($event)"
    ></lib-widget>
  `,
  styles: []
})
export class PortletComponent implements OnInit, OnChanges {
  /**
   * 下面两者任意一个必选
   * 哪个变化后有值，就用哪个
   */
  @Input() portletId: string
  @Input() portlet: EppPortlet
  /**
   * 优先级：
   * pvs.title > portlet @Input() title > portlet.name
   */
  @Input() title: string
  /**
   * 外部塞来的额外配置值，在卡片自身配置之上，再叠加本配置。
   * 现用于页面设计器中的卡片配置。
   * optional。
   */
  @Input() propValues = {}
  /** optional */
  @Input() portletNamesUsingDemoData: string[] = []
  /** optional */
  @Input() getCustomizedData: () => Observable<any>
  /** optional */
  @Input() instanceId: string
  /** optional */
  @Input() linkMap: LinkConfig
  /**
   * 初始化时就带入的 dp values，现用于实现弹窗打开部件，同时传入筛选值
   * optional
   */
  @Input() initDpValues: DpValue[]
  /** 筛选条件 */
  @Input() queryConditions: QueryCondition[]
  /** 初始筛选配置 + 值 */
  @Input() initFilterDpFsValList: DpFsVal[]

  // @Output() init = new EventEmitter()

  /** 发出初始化好的 widgetComponent */
  @Output() widgetInit = new EventEmitter()
  /** 获取到 portlet 元数据事件，将 portlet 传出 */
  @Output() gotPortlet = new EventEmitter<EppPortlet>()
  @Output() widgetCompCreated = new EventEmitter<WidgetComponent>()

  @ViewChild('widget') widgetComp: WidgetComponent

  /** 通过外部输入计算得到的真正渲染的 portlet */
  public innerPortlet: EppPortlet
  /** 内部配置值 + 外部配置值（高优先级）合并生成的新配置值，此值被塞给 wComp */
  public resultPropValues

  constructor (
    private portletAnonymityRepo: PortletAnonymityRepo,
    private dataResultsetAnonymityRepo: DatasetAnonymityRepo,
    private http: HttpClient,
    private cd: ChangeDetectorRef,
    private utilService: UtilService,
  ) { }

  ngOnInit () {
    portletComps.push(this)
    if (!this.inited) this.initByPortletOrId(this.portletId, this.portlet)
  }

  ngOnChanges (changes: SimpleChanges): void {
    if (changes.portletId && changes.portletId.currentValue) {
      this.initByPortletOrId(changes.portletId.currentValue, null)
    } else if (changes.portlet && changes.portlet.currentValue) {
      this.initByPortletOrId(null, changes.portlet.currentValue)
      // this.innerPortlet = changes.portlet.currentValue
    } else if (changes.queryConditions && changes.queryConditions.currentValue) {
      // 触发元部件加载数据
      this.widgetComp.loadNSetData()
    }
  }
  inited
  initByPortletOrId (portletId: string, portlet: EppPortlet) {
    this.inited = false
    if (portletId) {
      this.portletAnonymityRepo.getPortletById(portletId).subscribe(p => {
        this.innerPortlet = p
        this.updateResultPropValues()
        this.gotPortlet.emit(p)
        this.cd.markForCheck()
      }, err => {
        this.widgetComp.status = WCStatus.WidgetLoadError
      })
    } else if (portlet) {
      this.innerPortlet = portlet
    }
  }
  /**
   * 部件取数逻辑：
   * - 有外部手工数据：用手工数据
   * - 无手工数据
   *    - 数据集
   *      - 配了：取真数据
   *      - 没配
   *        - 名字带着演示字样：取演示数据
   *        - 名字未带演示字样：给空数据
   *    - 静态数据：给静态数据
   * 
   * 打平：
   * 1. 有外部手工数据
   * 2. 数据集 + 配了
   * 3. 数据集 + 没配 + 名字带演示
   * 4. 数据集 + 没配 + 名字不带演示
   * 5. 静态数据
   * TODO: 考虑此方法与 portletEditorComponent.loadNSetData 的关系?
   * @param getDataOpts 
   * @returns 
   */
  getData = (getDataOpts: GetDataOptions) => {
    // TODO: 这部分都应该由外面处理，仅区分出一个 getCustomizedData()
    // 1. 有外部手工数据
    if (this.getCustomizedData) {
      // 若名中含有某些字，则用演示数据
      // 加个 delay 是为了变成异步调用。否则从注册，到里面的 setData，会同步调用，可怕。
      return this.getCustomizedData().pipe(delay(0))
    } else {
      if (!this.innerPortlet) return
      if (Portlet.GetIfIsDataType(this.innerPortlet, 'dataset')) {
        if (!this.innerPortlet.id) return
        if (this.innerPortlet.datasetId !== null) {
          // 2. 数据集 + 配了
          return this.dataResultsetAnonymityRepo.getResultByPortletId(
            this.innerPortlet.id,
            getDataOpts.dpValues,
            convertQueryConditions(this.queryConditions),
            getDataOpts.runtimeAgg,
          )
        } else {
          if (
            this.portletNamesUsingDemoData
              .some(name => this.innerPortlet.name && this.innerPortlet.name.includes(name))
          ) {
            // 3. 数据集 + 没配 + 名字带演示
            return this.getDemoData().pipe(delay(0))
          } else {
            // 4. 数据集 + 没配 + 名字不带演示
            return of([])
          }
        }
      } else if (Portlet.GetIfIsDataType(this.innerPortlet, 'static')) {
        // 5. 静态数据
        return of({
          dimensions: Object.keys(this.innerPortlet.extra.staticData[0])
            .map(colName => ({ name: colName })),
          tableData: this.innerPortlet.extra.staticData
        })
      } else if (Portlet.GetIfIsDataType(this.innerPortlet, 'custom')) {
        return fromPromise(this.utilService.loadNGetCustomGetDataDimsNData(this.innerPortlet.extra.customGetData))
      }
    }
  }
  getDataWithDims = () => {

  }

  handleWidgetInit () {
    this.widgetInit.emit()
  }
  handleWidgetCompCreated (params) {
    if (this.initDpValues) this.widgetComp.setLinkDpValues(this.initDpValues)
    this.widgetCompCreated.emit(params)
  }

  /** 获取演示数据 */
  // TODO: 等验证完成没问题后，挪到 util service 之类里面去，config service 啥的都可以在 util，部件系统一定生存在 iGIX 里。
  getDemoData () {
    return this.getHomeConfig().pipe(map(config => config.data[curLang]))
  }
  getHomeConfig (): Observable<any> {
    return this.http.get(`${WEB_PATH_HOME}assets/home.config.json`)
  }

  public cleanAllLink () {
    this.widgetComp.cleanAllLink()
  }
  /** 没用上 */
  public setPropValues (propName: string, value) {
    this.propValues[propName] = value
    this.updateResultPropValues()
  }
  /**
   * merge 出 resultPropValues
   * 外部值有变化时、内部值加载成功时，都尝试调用此方法，更新合并配置值。
   */
  updateResultPropValues () {
    if (!this.innerPortlet) return
    this.resultPropValues = deepMergeKey(this.innerPortlet.propValues, true, this.propValues)
  }

}

function convertQueryConditions (conditions: QueryCondition[]) {
  if (!conditions) return '""'
  const entityData: any = { id: 'undefined_null' };
  conditions.forEach(c => {
    const { fieldCode } = c;
    const value: any = c.value;
    let tempValue
    if (value && (value.dateValue || value.value || value.numValue || value.yearValue
        || value.startTime || value.endTime || value.startValue || value.endValue)) {
      switch (c.control.getControlType()) {
        case 0: // Text
          tempValue = value.value;
          break;
        case 1: // SingleDate
          tempValue = value.dateValue;
          break;
        case 2: // SmartHelp
          tempValue = value.value[value.valueField];
          break;
        case 3: // DropDownList
          tempValue = value.value.value;
          break;
        case 4: // DateRange
          tempValue = {
            beginValue: value.startTime ? value.startTime : 0,
            endValue: value.endTime ? value.endTime : 0
          }; // tempData.value;
          break;
        case 5: // NumberRange
          tempValue = {
            beginValue: value.startValue ? value.startValue : 0,
            endValue: value.endValue ? value.endValue : 0
          }; // tempData.value;
          break;
        case 6: // SingleNumber
          tempValue = value.numValue;
          break;
        case 7: // SingleYear
          tempValue = value.yearValue;
          break;
        case 8: // BoolCheck
          tempValue = value.value && value.value.length ? value.value[0] : value.value;
          break;
        case 9: // DateTimeRange
          tempValue = {
            beginValue: value.startValue ? value.startValue : 0,
            endValue: value.endValue ? value.endValue : 0
          }; // tempData.value;
          break;
        default:
          break;
      }
      // 根据 field code 组合 entity data
      if (fieldCode && fieldCode.includes(';')) {
        const fields1 = fieldCode.split(';')[0].split('.');
        const fields2 = fieldCode.split(';')[1].split('.');
        setEntityData(fields1, entityData, tempValue['beginValue']);
        setEntityData(fields2, entityData, tempValue['endValue']);
      } else {
        const fields = fieldCode.split('.');
        setEntityData(fields, entityData, tempValue);
      }
    }
  })
  return entityData
}

function setEntityData (fields: any[], entityData: any, tempData: any) {
  if (fields.length && fields.length > 1) {
    for (let i = 0; i < fields.length; i++) {
      if (i === 0) {
        entityData = prepareEntityData(fields[i], entityData);
      } else {
        entityData = prepareEntityData(fields[i], entityData[fields[i - 1]]);
      }
      if ((i + 1) === fields.length) {
        entityData[fields[i]] = tempData;
      }
    }
  } else {
    entityData[fields[0]] = tempData;
  }
}
function prepareEntityData (key: string, entityData: any): any {
  if (!entityData.hasOwnProperty(key)) entityData[key] = {}
}


export class QueryCondition {
  id: string;
  leftBrackets: string;
  fieldCode: string;
  fieldName: string;
  name: string;
  compareType: CompareType;
  valueType: ValueType;
  /**
   * 值
   * 该属性为IValue接口，根据不同的控件类型有不同的实现类：具体如下：
   * 1. 文本类型：TextValue
   * 2. 下拉列表：DropDownListValue
   * 3. 日期区间：DateRangeValue
   * 4. 数字区间：NumberRangeValue
   * 5. 帮助类型：SmartHelpValue
   */
  value: IValue;
  rightBrackets: string;
  relationType: RelationType;
  /**
   * 控件类型，目前包括文本类型，下拉列表，日期区间，数字区间，帮助类型
   * 控件类型为IControl接口，根据不同的控件类型对应不同的实现类，具体如下：
   * 1. 文本类型：TextControl
   * 2. 下拉列表：DropDownListControl
   * 3. 日期区间：DateRangeControl
   * 4. 数字区间：NumberRangeControl
   * 5. 帮助类型：SmartHelpContol
   */
  control: IControl;
}
export enum CompareType {
    Equal = 0,
    GreaterThan= 2,
    GreaterThanOrEqual= 3,
    LessThan = 4,
    LessThanOrEqual = 5,
    BetWeen= 6
}
export enum ValueType {
  Value= 0,
  SmartHelp= 1,
  Enum= 2,
  Express= 3
}

export interface IValue {
  getControlType (): ControlType;
  getOriginalValue (): any;
  setOriginalValue (value: any): void;
  clearValue (): void;
  isEmpty (): boolean;
}

export enum RelationType {
  And= 0,
  Or= 1
}
export interface IControl {
  /**
   * 是否是展示在扩展区域内的
   */
  isExtend: boolean;
  required: boolean;
  /** 日期需要增加类型比较 */
  compareType?: CompareType;
  /**
   * 获取控件类型
   */
  getControlType (): ControlType;
}
export enum ControlType {
  Text= 0,
  // DateTime=1,
  Help= 1,
  DropDown= 2,
  DateRange= 3,
  NumberRange= 4,
  Search= 5,
  Date= 6,
  CheckboxGroup= 7,
  DateRangeTime= 8
}


registerLinkToPropEventHandler((config: ClickEventConfig, dataItem) => {
  const { toPortlet, toProp, paramExp } = config
  const portletComp = findPortletCompByPortletId(toPortlet)
  if (portletComp && portletComp.widgetComp) {
    portletComp.widgetComp.setPropertyValue(toProp, jexl.evalSync(paramExp, {
      ...dataItem
    }))
  }
})

function findPortletCompByPortletId (portletId: string): PortletComponent {
  return portletComps.find(pc => pc.innerPortlet && pc.innerPortlet.id === portletId)
}

const portletComps: PortletComponent[] = []


registerOpenPortletFn((
  toOpenPortletId: string,
  dpValues: DpValue[],
  widgetDevkit: WidgetDevkitService,
) => {
  const modal = widgetDevkit.openNzModal({
    nzContent: PortletComponent,
    nzComponentParams: {
      portletId: toOpenPortletId,
      initDpValues: dpValues,
    } as PortletComponent,
    nzFooter: null,
    nzWidth: 800,
    nzBodyStyle: {
      height: '500px',
    },
  })

  const a = modal.getContentComponent()
})
